import * as React from 'react';

export interface PVAActionsButtonItem {
    id: string | number;
    name: string;
    callback: () => void;
    icon?: string;
    description?: string;
}

export interface PVAActionsButtonGroup {
    header?: string;
    items: PVAActionsButtonItem[];
}

export interface PVAActionsButtonProps {
    groups: PVAActionsButtonGroup[];
    label?: string;
    disabled?: boolean;
}

export interface PVAActionsButtonState {
    open: boolean;
}

export class PVAActionsButton extends React.Component<PVAActionsButtonProps, PVAActionsButtonState> {
    constructor(props: PVAActionsButtonProps) {
        super(props);
        this.state = {
            open: false
        };
    }

    private toggle = () => {
        this.setState({ open: !this.state.open });
    }

    render() {
        const { groups, label, disabled } = this.props;
        const { open } = this.state;

        return (
            <div className={`dropdown ${disabled ? 'disabled' : ''}`}>
                <button type="button" className="btn btn-primary" onClick={this.toggle} disabled={disabled}>
                    <span className="glyphicon glyphicon-th-list"></span>
                    <span> {label || 'Actions'}</span>
                </button>
                {!disabled && (
                    <ul className={`action-menu dropdown-menu ${open ? 'open' : ''}`}>
                        {groups.map((group: PVAActionsButtonGroup, gInd: number) => (
                            <React.Fragment key={`action-group-${gInd}`}>
                                {group.header && <li className="options-header">{group.header}</li>}
                                {group.items.map((item: PVAActionsButtonItem) => {
                                    return (
                                        <li key={`action-item-${item.id}`} className="options-entry" onClick={() => { this.toggle(); item.callback(); }}>
                                            <div className="options-entry-title">
                                                {item.icon && (item.icon.endsWith('.svg') ? <img src={`/images/${item.icon}`} /> : <span className={`glyphicon ${item.icon}`} />)}
                                                <span> {item.name}</span>
                                            </div>
                                            {item.description && <div className="options-entry-desc">{item.description}</div>}
                                        </li>
                                    );
                                })}
                            </React.Fragment>
                        ))}
                    </ul>
                )}
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/reports/blocks/PVAActionsButton.tsx